module.exports = __webpack_public_path__ + "static/img/deviceroom.01480d11.svg";